import { SelectOptionType } from '@octano/global-ui';
import { SecureResponseFile } from '../../../components/AzureFilesUploader/types';
import { StudentsRemovalRequestFormFile } from './types/students';

export const convertToFormFile = (
  item: SecureResponseFile,
): StudentsRemovalRequestFormFile => ({
  id: item.id,
  name: `${item.name}.${item.extension}`,
});

export const convertToSelectOption = (
  item?: {
    id: number;
    name: string;
  } | null,
): SelectOptionType | null =>
  item
    ? {
        value: item.id,
        label: item.name,
      }
    : null;
